import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/auth/forgot-password/success/page";

export const Route = createFileRoute("/auth/forgot-password/success")({
  component: Page,
});
